import {useEffect, useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import {Tooltip} from '../../../../components/Tooltip/Tooltip'
import Edit from '../../../../media/felsv/DarkEditPencil.svg'
import {SerieDocumento} from '../useSeriesDocumentos'

interface PropiedadesTablaSeries {
  series: Array<SerieDocumento>
  onCorregir: (documento: SerieDocumento) => void
}

const estiloEtiqueta = (cumple: boolean) => ({
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: '12px',
  fontSize: '12px',
  whiteSpace: 'nowrap' as const,
  background: cumple ? '#dcfce7' : '#fef3c7',
  color: cumple ? '#15803d' : '#b45309',
})

const TablaSeries = ({series, onCorregir}: PropiedadesTablaSeries) => {
  const [paginaSeries, setPaginaSeries] = useState<Array<SerieDocumento>>([])

  useEffect(() => {
    if (series.length === 0) setPaginaSeries([])
  }, [series])

  return (
    <div className='tab-plane' style={{overflowX: 'auto'}}>
      <table className='table-main-responsive responsive-table-main td-left table-pointer'>
        <thead>
          <tr>
            <td>Sucursal</td>
            <td>Documento</td>
            <td>Serie</td>
            <td>Formato 2.0</td>
            <td>Número actual</td>
            <td>Acciones</td>
          </tr>
        </thead>
        <tbody>
          {paginaSeries.map((documento, indice) => (
            <tr key={indice} style={{opacity: documento.estado ? '1' : '0.5'}}>
              <td data-label='Sucursal'>{documento.nombreSucursal}</td>
              <td data-label='Documento'>{documento.nombreDocumento}</td>
              <td data-label='Serie'>
                <strong>{documento.serie || 'Sin serie'}</strong>
              </td>
              <td data-label='Formato 2.0'>
                <span style={estiloEtiqueta(documento.cumpleFormatoV2)}>
                  {documento.cumpleFormatoV2 ? 'Correcta' : 'Por corregir'}
                </span>
              </td>
              <td data-label='Número actual'>{parseInt(documento.numeroactual || '0', 10)}</td>
              <td data-label='Acciones' className='table-td'>
                <Tooltip content='Corregir serie'>
                  <button className='table-action' onClick={() => onCorregir(documento)}>
                    <img src={Edit} alt='Corregir serie' className='table-img-action' />
                  </button>
                </Tooltip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        data={series}
        state={(elementos: Array<SerieDocumento>) => setPaginaSeries(elementos)}
        items={10}
      />
    </div>
  )
}

export default TablaSeries
